<template>
    <!--
            @edit-image="editImage"
            @data-change="dataChange"
    -->
    <VueUploadMultipleImage
            @upload-success="uploadImageSuccess"
            @before-remove="beforeRemove"

            :data-images="getImages"
            :maxImage="50"
            dragText="Sleep hier uw afbeeldingen"
            dropText="Laat los om te uploaden"
            browseText="Of klik hier om te selecteren"
            popupText="Deze afbeelding zal als eerste worden geplaatst."
            markIsPrimaryText="Maak uitgelicht"
            primaryText="Uitgelicht"
            class="mt-4"
            :showPrimary="false"
    ></VueUploadMultipleImage>
</template>

<script>
	import VueUploadMultipleImage from 'vue-upload-multiple-image'
	import { ADD_IMAGE, REMOVE_IMAGE } from '@/store/modules/images'

	export default {
		components: { VueUploadMultipleImage },

		props: {
			type: {
				type: String,
				required: true,
			},
			typeID: {
				type: Number,
				required: true,
			},
			images: {
				type: Array,
				required: true,
				default: function () {
					return []
				},
			},
		},

		computed: {
			getImages () {
				return this.images.map((image, index) => {
					return {
						id: image.id,
						path: image.paths.hd,
						highlight: (
							index === 0 ? 1 : 0
						),
					}
				})
			},
		},

		methods: {
			uploadImageSuccess (formData, index, fileList) {
				this.$store.dispatch(ADD_IMAGE, {
					type: this.type,
					id: this.typeID,
					data: fileList[index],
				}).then((response) => {
					fileList[index].id = response.id
				})
			},
			beforeRemove (index, done, fileList) {
				this.$store.dispatch(REMOVE_IMAGE, {
					type: this.type,
					id: fileList[index].id,
				}).then(() => {
					done()
				})
			}
		},
	}
</script>